import { MoneyWavy } from '@phosphor-icons/react';
import { Check } from '@phosphor-icons/react/dist/ssr';
import { Alert, Flex } from 'antd';
import { useAuth } from '~/context/AuthContext ';

import { useMemo, useState } from 'react';
import { AmountObject } from '~/services/pay';
import { amountArr } from '../const';
import { formatAmount } from '~/utils/function';
import CurrencyInput from './CurrencyInput';
import { isCreatorOrDev } from '~/utils/const';
import PayCode from './PayModal/payCode';

import './index.less';

const PluginComponent = ({show = false}: {show?: boolean}) => {
  const { userInfo } = useAuth();
  const [currentSelect, setCurrenSelect] = useState<AmountObject>(amountArr[4] as AmountObject);

  const [customOrder, setCustomOrder] = useState<number | null>(amountArr[0]?.value || 10);

  const onChangeSelect = (value = 1) => {
    const curValue = Math.max(Math.floor(value), 1);
    setCurrenSelect({ key: 'CUSTOM', value: curValue });
    setCustomOrder(curValue);
  };

  const showCustom = useMemo(() => isCreatorOrDev(userInfo?.role), [userInfo?.role]);

  return (
    <>
      <Alert
        className="packages-alert mb-3"
        message="本充值金额仅用于简创 AIGC 插件的功能调用。"
        type="info"
        showIcon
        closable
      />
      <div className="recharge-section-content">
        <div className="recharge-balance-module fade-in" style={{ animationDelay: '0.2s' }}>
          <div className="recharge-options mod-card">
            <div className="recharge-header">
              <span className="recharge-icon">
                <MoneyWavy size={64} weight="fill" />
              </span>
              <h3>选择充值金额</h3>
            </div>
            <div className="recharge-amount-options">
              {amountArr.map((item, index) => {
                if (item.key === 'CUSTOM') {
                  return;
                }
                const { key, value, bonus } = item;
                return (
                  <div
                    className={`recharge-amount-option ${key === currentSelect.key ? 'active' : ''}`}
                    key={`${key}_${index}`}
                    onClick={() => setCurrenSelect(item)}
                  >
                    <Flex
                      className="recharge-amount-value h-full"
                      vertical
                      align="center"
                      justify="center"
                    >
                      <span className="amount">{formatAmount(value, { currency: '¥' })}</span>
                      {bonus ? <span className="bonus">赠送{bonus}</span> : <span className="no-bonus">无赠送</span>}
                    </Flex>
                    {key === currentSelect.key && (
                      <div className="recharge-amount-check">
                        <Check weight="bold" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            {showCustom && (
              <div
                className={`recharge-amount-custom mb-3 ${'CUSTOM' === currentSelect.key ? 'active' : ''}`}
              >
                <Flex align="center" onClick={() => onChangeSelect(customOrder || 10)}>
                  <span className="mb-0 mr-[8px]">自定义金额</span>
                  <CurrencyInput value={customOrder} onChange={onChangeSelect} unit="¥" />
                  {'CUSTOM' === currentSelect.key && (
                    <div className="recharge-amount-check">
                      <Check weight="bold" />
                    </div>
                  )}
                </Flex>
              </div>
            )}
          </div>
          <div className="recharge-divider"></div>
          <div className="recharge-pay-module">
            <PayCode open={show} currentSelect={currentSelect} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PluginComponent;
